import React from 'react'

const DefaultPage = React.lazy(() => import('./DefaultPage'))

export default {
  path: '/',
  name: 'Home',
  childRoutes: [
    {name: 'default', path: '', component: DefaultPage, isIndex: true}
  ]
};



// WEBPACK FOOTER //
// ./src/features/home/route.js